// @ts-nocheck
import { validationErrorSelector } from "@store/Framework/Store/Bunzl/Pages/Reporting/ReportApi/ReportAPISelectors";
import { useDispatch, useSelector } from "react-redux";

export const useValidationError = () => {
    const dispatch = useDispatch();
    const validationError = useSelector(validationErrorSelector);

    const setValidationError = (error: boolean) => {
        dispatch({
            type: "Store/Pages/reportAPI/setValidationError",
            action: error,
        });
    };
    return [validationError, setValidationError] as const;
};
